module.exports = __webpack_public_path__ + "static/media/rosa-lose.a2d8de68.png";